
class Storage {
    static getItem = (key) => {

        return JSON.parse(JSON.parse(localStorage.getItem(key)));
    }

    static setItem = (key, value) => {
        let str = JSON.stringify(value);
        localStorage.setItem(key, str);
    }

    static clear = () => {
        localStorage.clear();
    }

    static getAuth = () => {
        let user = this.getItem('CurrentUser');
        if (!user) {
            return {};
        }
        else {
            return { UserId: user.userId, Token: user.token };
        }
    }
}

export default Storage